import { render, staticRenderFns } from "./ComponentEditor.vue?vue&type=template&id=9780a1c4&scoped=true&"
import script from "./ComponentEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEditor.vue?vue&type=style&index=0&id=9780a1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780a1c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VSelect,VTextField,VTextarea})
